
import axiosClient from "../../../../api/axiosClient";

const BASE_URL = "/api/trading/sales-invoices";

const tradingSalesInvoiceService = {
  getSalesInvoiceList(params = {}) {
    return axiosClient.get(`${BASE_URL}/`, { params });
  },

  getAvailableDeliveryChallans(params = {}) {
    return axiosClient.get(
      `${BASE_URL}/available-delivery-challans`,
      { params }
    );
  },

  getAvailableDeliveryChallanItems(params = {}) {
  const queryParams =
    typeof params === "object"
      ? params
      : params
      ? { delivery_challan_id: params }
      : {};

  return axiosClient.get(
    `${BASE_URL}/available-delivery-challan-items`,
    { params: queryParams }
  );
},

  getAvailableDeliveryChallanItems_old(deliveryChallanId) {
    return axiosClient.get(
      `${BASE_URL}/available-delivery-challan-items`,
      {
        params: deliveryChallanId
          ? { delivery_challan_id: deliveryChallanId }
          : {},
      }
    );
  },

  getSalesInvoiceDetail(invoiceId) {
    return axiosClient.get(`${BASE_URL}/${invoiceId}`);
  },

  createSalesInvoice(payload) {
    return axiosClient.post(`${BASE_URL}/`, payload);
  },

  updateSalesInvoice(invoiceId, payload) {
    return axiosClient.put(`${BASE_URL}/${invoiceId}`, payload);
  },

  submitSalesInvoiceForApproval(invoiceId, payload = {}) {
    return axiosClient.post(
      `${BASE_URL}/${invoiceId}/submit-for-approval`,
      payload
    );
  },

  approveSalesInvoice(invoiceId, payload = {}) {
    return axiosClient.post(
      `${BASE_URL}/${invoiceId}/approve`,
      payload
    );
  },

  rejectSalesInvoice(invoiceId, payload = {}) {
    return axiosClient.post(
      `${BASE_URL}/${invoiceId}/reject`,
      payload
    );
  },

  cancelSalesInvoice(invoiceId, payload = {}) {
    return axiosClient.post(
      `${BASE_URL}/${invoiceId}/cancel`,
      payload
    );
  },

  postSalesInvoice(invoiceId, payload = {}) {
    return axiosClient.post(
      `${BASE_URL}/${invoiceId}/post`,
      payload
    );
  },

  getSalesInvoiceAuditHistory(invoiceId) {
    return axiosClient.get(
      `${BASE_URL}/${invoiceId}/audit-history`
    );
  },
};

export default tradingSalesInvoiceService;
